import { AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@component/dialog";
import { Button } from "@component/button";

interface SaveCampaignConfirmDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    contactCount: number;
    timingMode: string;
    scheduledDate?: string;
    scheduledTime?: string;
    title?: string;
    confirmLabel?: string;
}

export function SaveCampaignConfirmDialog({
    open,
    onOpenChange,
    onConfirm,
    contactCount,
    timingMode,
    scheduledDate,
    scheduledTime,
    title = "Save Campaign",
    confirmLabel = "Confirm & Save",
}: SaveCampaignConfirmDialogProps) {
    const isImmediate = timingMode === "immediate";

    const formattedDateTime = scheduledDate && scheduledTime
        ? new Date(`${scheduledDate}T${scheduledTime}`).toLocaleString("en-GB", {
            dateStyle: "medium",
            timeStyle: "short",
        })
        : null;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <div className="flex items-start gap-3 mb-4">
                    <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                    <div className="text-sm text-gray-600 space-y-2">
                        {isImmediate ? (
                            <p>Calling will begin <strong>immediately</strong> for <strong>{contactCount}</strong> contact{contactCount !== 1 ? "s" : ""}.</p>
                        ) : (
                            <p>Campaign will begin on <strong>{formattedDateTime || "the scheduled date/time"}</strong> for <strong>{contactCount}</strong> contact{contactCount !== 1 ? "s" : ""}.</p>
                        )}
                        <p>Are you sure you want to proceed?</p>
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
